// extracted by mini-css-extract-plugin
export default {"inner":"ArticlesPage_inner__1qM1l","list":"ArticlesPage_list__-Iv-u"};